import { useState, useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { IMAGES } from "../data/site";

const ITEMS = [
    { src: IMAGES.exterior, label: "Salon Girişi" },
    { src: IMAGES.corridor, label: "Salon Koridoru" },
    { src: IMAGES.tigerRoom, label: "Kaplan Odası" },
    { src: IMAGES.redRoom, label: "Kızıl Oda" },
    { src: IMAGES.greenRoom, label: "Zümrüt Odası" },
    { src: IMAGES.sultan, label: "Sultan Masajı" },
    { src: IMAGES.thai, label: "Thai Masajı" },
    { src: IMAGES.jakuzi, label: "Jakuzi Odası" },
    { src: IMAGES.stones, label: "Sıcak Taş" },
    { src: IMAGES.oil, label: "Aromaterapi Yağları" },
    { src: IMAGES.candles, label: "Mumlu Atmosfer" },
    { src: IMAGES.petal, label: "Masaj Detayı" },
];

export default function Gallery() {
    const [idx, setIdx] = useState(-1);

    useEffect(() => {
        if (idx < 0) return;
        const onKey = (e) => {
            if (e.key === "Escape") setIdx(-1);
            if (e.key === "ArrowRight") setIdx((i) => (i + 1) % ITEMS.length);
            if (e.key === "ArrowLeft")
                setIdx((i) => (i - 1 + ITEMS.length) % ITEMS.length);
        };
        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", onKey);
        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("keydown", onKey);
        };
    }, [idx]);

    return (
        <section
            id="galeri"
            data-testid="gallery-section"
            className="section bg-[#0d0d0f]"
        >
            <div className="container-x">
                <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
                    <div className="eyebrow mb-3">Galeri</div>
                    <h2 className="h2 text-[#f2ede4]">Salondan Anlar</h2>
                    <div className="divider-gold mt-5 mx-auto" />
                    <p className="mt-5 body-base">
                        Salonumuzun içinden ve odalarımızdan gerçek fotoğraflar.
                    </p>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                    {ITEMS.map((it, i) => (
                        <button
                            key={i}
                            onClick={() => setIdx(i)}
                            data-testid={`gallery-item-${i}`}
                            className="group relative aspect-square overflow-hidden rounded-lg bg-[#17171b] border border-[#26262c] hover:border-[#c9a24b]/50 transition-colors"
                            aria-label={`${it.label} görselini büyüt`}
                        >
                            <img
                                src={it.src}
                                alt={`${it.label} - Cegu Masaj`}
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                            />
                            <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                                <div className="text-[12px] font-medium text-white">
                                    {it.label}
                                </div>
                            </div>
                        </button>
                    ))}
                </div>
            </div>

            {/* Lightbox */}
            {idx >= 0 && (
                <div
                    className="lightbox-overlay"
                    onClick={() => setIdx(-1)}
                    data-testid="lightbox"
                >
                    <button
                        onClick={() => setIdx(-1)}
                        aria-label="Kapat"
                        className="absolute top-4 right-4 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white"
                    >
                        <X className="w-5 h-5" />
                    </button>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            setIdx((i) => (i - 1 + ITEMS.length) % ITEMS.length);
                        }}
                        aria-label="Önceki"
                        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white"
                    >
                        <ChevronLeft className="w-5 h-5" />
                    </button>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            setIdx((i) => (i + 1) % ITEMS.length);
                        }}
                        aria-label="Sonraki"
                        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white"
                    >
                        <ChevronRight className="w-5 h-5" />
                    </button>
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className="max-w-5xl w-full"
                    >
                        <img
                            src={ITEMS[idx].src}
                            alt={ITEMS[idx].label}
                            className="w-full h-auto max-h-[85vh] object-contain rounded-lg"
                        />
                        <div className="mt-3 text-center text-[13px] text-[#c8c3ba]">
                            {ITEMS[idx].label} · {idx + 1} / {ITEMS.length}
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
